import { render, staticRenderFns } from "./AssemblyComponent.vue?vue&type=template&id=579d49d4"
import script from "./AssemblyComponent.vue?vue&type=script&lang=ts"
export * from "./AssemblyComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports